import { ChatsManagerProvider } from '../../../../app/modules/core/Providers/chats-manager';
import { SocketQuery } from '../../../../bayadic-shared-models/classes/system/sockets/SocketQuery.class';
import { Chat } from '../../../../bayadic-shared-models/chat/Chat';
import { AbstractChatMessage } from '../../../../bayadic-shared-models/classes/message/abstract-chat-message';
import { GetNewMessagesRequest, GetNewMessagesResponse, GetOlderMessagesRequest, GetOlderMessagesResponse } from '../../../../bayadic-shared-models/messages/get-new-messages-request';
import { ACTIONS } from '../../../../bayadic-shared-models/enums/Enums';
import { MessageData } from '../../../../bayadic-shared-models/classes/message/message-data';
import { ITEM_TYPES } from '../../../../bayadic-shared-models/item/item-types';
import { Message } from '../../../../bayadic-shared-models/messages/message';
import { MESSAGE_TYPES } from '../../../../bayadic-shared-models/item/message-types';
import { LessonContentType } from '../../../../bayadic-shared-models/classes/message/lesson-content-type';
import { RemoveMessageResponse } from '../../../../bayadic-shared-models/item/remove-message-response';
import { RemoveMessageRequest } from '../../../../bayadic-shared-models/item/remove-message-request';
import { of } from 'rxjs';
import { ChatFront } from '../../../../app/modules/chat/ChatFront';
import { LoggerService } from '../../../../app/services/logger.service';
export class Synchronizer {
    public chatMgr: ChatsManagerProvider;
    public static loadMoreMessages = "loadMoreMessages";
    public static getMoreMessages = "getMoreMessages";
    public static action1 = "";
    public static action2 = "";
    public syncing: boolean = false;
    isGettinOlderMessages: boolean = false;
    isGettingLatestMessages: boolean = false;
    isGettingScheduledOlderMessages: boolean = false;
    constructor(chatMgr: ChatsManagerProvider,
        public logger: LoggerService
    ) {
        this.chatMgr = chatMgr;
    }
    public async getOlderMessagesFromLocalDB(chat: Chat, pageSize: number): Promise<AbstractChatMessage[]> {
        const messages = await this.chatMgr.databaseService.readPagesOfMessage(chat, pageSize)
        return this.buildAndPrependMessages(messages, chat);
    }

    public async getOlderScheduledMessagesFromLocalDB(chat: Chat){
        const messages = await this.chatMgr.databaseService.readScheduledBeforeToday(chat, 20)

        
        return this.buildAndPrependScheduledMessages(messages, chat);
    }
    private buildAndPrependScheduledMessages(messages: MessageData<any>[], chat: Chat) {
        if (messages && messages.length > 0 && messages[0].messageID != chat.scheduledMessages[0]?.messageID) {
            const messagesToAdd = messages.map(it => this.chatMgr.buildMessageFromMessageData(it)).reverse();
            messagesToAdd.forEach((oldMessage) => {
                oldMessage.scheduled = true;
                chat.scheduledMessages.unshift(oldMessage);
            });
            return messagesToAdd;
        }
        return [];
    }
    private buildAndPrependMessages(messages: MessageData<any>[], chat: Chat): AbstractChatMessage[] {
        const filteredMessages = messages.filter((message) => {
            return !chat.messages.some((chatMessage) => chatMessage.messageID == message.messageID);
        });
        if (filteredMessages && filteredMessages.length > 0 && filteredMessages[0].messageID != chat.messages[0]?.messageID) {
           
            const messagesToAdd = filteredMessages.map(it => this.chatMgr.buildMessageFromMessageData(it)).reverse();
            this.logger.debug("messagesToAdd", messagesToAdd)
            messagesToAdd.forEach((oldMessage) => {
                chat.messages.unshift(oldMessage);
            });

            
            return messagesToAdd;
        }
        return [];
    }
    private buildAndAppendMessages(messages: MessageData<any>[], chat: Chat) {
        if (messages && messages.length > 0 && messages[0].messageID != chat.messages[0]?.messageID) {
            const messagesToAdd = messages.map(it => this.chatMgr.buildMessageFromMessageData(it));
            messagesToAdd.forEach((oldMessage) => {
                chat.messages.push(oldMessage);
                this.logger.debug("append new message", oldMessage)
            });
            return messagesToAdd;
        }
        return [];
    }

    private async getOlderMessagesFromCloud(chat: Chat, pageSize: number = 5): Promise<AbstractChatMessage[] | false> {
        if (this.isGettinOlderMessages) {
            return false;
        }
        this.isGettinOlderMessages = true;
        const requestData =  { 
            itemID: chat.item.itemID, 
            length: pageSize, 
            olderThanMessageID: chat.getFirstMessageID(),
         }
        const result = await this.chatMgr.socketManager.asyncQuery<GetOlderMessagesResponse, GetOlderMessagesRequest>(
            ACTIONS.getOlderMessage,
            requestData
        )
        
        if (!result || !result.messages) {
            this.isGettinOlderMessages = false;
            return [];
        }
        
        const sortedMessages = result.messages.sort((a, b) => {
            return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
        });
        const messages = this.buildAndPrependMessages(sortedMessages, chat)
        await this.addMessagesToDB(messages, chat);
        this.isGettinOlderMessages = false;
        return messages;
    }
    private async addMessagesToDB(messages: AbstractChatMessage[], chat: Chat) {
        if (messages.length === 0) return;
        const messageData = messages.map(message => message.getMessageData());
        await this.chatMgr.databaseService.addMessagesBulk(chat, messageData);
    }

    private async getOlderScheduledMessagesFromCloud(chat: Chat){
        if (this.isGettingScheduledOlderMessages) {
            return true;
        }
        this.isGettingScheduledOlderMessages = true;
        const result = await this.chatMgr.socketManager.asyncQuery<GetOlderMessagesResponse, GetOlderMessagesRequest>(
            ACTIONS.getOlderScheduledMessage,
            { itemID: chat.item.itemID, 
                length: 5, 
                olderThanMessageID: chat.getFirstScheduledMessageID(),
             }
        )
        this.buildAndPrependScheduledMessages(result.messages, chat)
        // for (const messageData of result.messages) {
        //     this.chatMgr.prependMessageToChat(messageData, chat);
        // }
        this.isGettingScheduledOlderMessages = false;
    }
    async getOlderScheduledMessage(chat: Chat) {
        const messagesFromDB = await this.getOlderScheduledMessagesFromLocalDB(chat)
        if(messagesFromDB.length < 20){
            await this.getOlderScheduledMessagesFromCloud(chat);
        }
        return true;
    }
    async getOlderMessages(chat: Chat, pageSize: number = 30):Promise<AbstractChatMessage[] | false> {
        let messages = await this.getOlderMessagesFromLocalDB(chat, pageSize);
        
        let messagesFromCloud: Array<AbstractChatMessage> = [];
        if(messages && messages.length < pageSize){
            const resultOfCloud = await this.getOlderMessagesFromCloud(chat, pageSize); 

            if(resultOfCloud){
                messagesFromCloud = resultOfCloud;
            }

        }
        await this.getOlderScheduledMessagesFromLocalDB(chat)
        return messages.concat(messagesFromCloud);
    }
    async getNewMessages(chat: Chat): Promise<AbstractChatMessage[] | false> {
        this.syncing = true;
        const lastMessageID = chat.getLastMessageID();
        if (!lastMessageID) return false
        const requestData = {
            lastMessageID: lastMessageID,
            itemID: chat.chatID,
            type: chat.type,
        };
        const response = await this.chatMgr.socketManager
            .asyncQuery<GetNewMessagesResponse, GetNewMessagesRequest>(ACTIONS.getNewMessages, requestData)

        this.logger.debug("new message response", response)

        const messages = this.buildAndAppendMessages(response.messages, chat);
        await this.addMessagesToDB(messages, chat);
        return messages;
    }
    async removeMessage(message: AbstractChatMessage, chat: Chat) {
        let data: RemoveMessageRequest = {
            messageID: message.messageID,
            itemID: chat.item.itemID,
        };
        this.logger.debug("remove message", this.chatMgr.userManager.user)
        if (message.isFrom(this.chatMgr.userManager.user) || true){

            this.logger.debug("removing")
            const result = await this.chatMgr.socketManager.asyncQuery<RemoveMessageResponse, RemoveMessageRequest>(ACTIONS.removeMessage, data);
            this.logger.debug("remove message result", result)
        }

        let messageIndex = chat.messages.indexOf(message);
        chat.messages.splice(messageIndex, 1);
    }
    onMessageRemoved(socketQuery: SocketQuery) {
        this.logger.debug("hura should remove");
    }
    public async hasLocalMessages(chat: Chat): Promise<boolean> {
        try {
            const messages = await this.getOlderMessagesFromLocalDB(chat, 1);
            return messages.length > 0;
        } catch (error) {
            console.error('Error checking local messages:', error);
            return false;
        }
    }
}